import styled, { css } from "styled-components"
import { TABLET_MAX_WIDTH, MOBILE_MIN_WIDTH } from "@constants"

export const StyledCatchUpSectionWrapper = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;

  & button {
    padding: 0 2rem;
  }
`

export const StyledCatchUpSectionContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-shrink: 0;
  width: 55rem;
  height: 20rem;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1018' height='496' viewBox='0 0 1018 496' fill='none'%3E%3Cpath d='M506 9.63672L100 247.637L506 485.637L912 247.637L506 9.63672Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M969 247.637L922 275.637L969 303.637L1016 275.637L969 247.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M188.5 334.637L166 347.637L188.5 360.637L211 347.637L188.5 334.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M298 10.6367L229 50.6367L298 90.6367L367 50.6367L298 10.6367Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M211 118.637L193 129.637L211 140.637L229 129.637L211 118.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M583 9.63672L565 20.6367L583 31.6367L601 20.6367L583 9.63672Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M114 155.637L79 176.637L114 197.637L149 176.637L114 155.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M799 57.6367L733 96.6367L799 135.637L865 96.6367L799 57.6367Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M849.5 167.637L832 177.637L849.5 187.637L867 177.637L849.5 167.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M947.5 164.637L922 179.637L947.5 194.637L973 179.637L947.5 164.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M668 23.6367L628 47.6367L668 71.6367L708 47.6367L668 23.6367Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M419 1.63672L394 16.6367L419 31.6367L444 16.6367L419 1.63672Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M849.5 316.637L775 360.637L849.5 404.637L924 360.637L849.5 316.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M732 413.637L714 424.637L732 435.637L750 424.637L732 413.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M620.5 442.637L584 465.137L620.5 487.637L657 465.137L620.5 442.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M283 399.637L213 440.637L283 481.637L353 440.637L283 399.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M62 268.637L2 306.137L62 343.637L122 306.137L62 268.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3Cpath d='M420.5 465.637L397 480.137L420.5 494.637L444 480.137L420.5 465.637Z' stroke='%23C4B180' stroke-width='2'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  padding: 5rem 0;

  & .circle-blur {
    display: none;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
      display: block;
    }
  }

  & .catchup-section__image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    & svg {
      transition: 0.5s;

      & path {
        transition: 0.2s;
      }
    }

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
      & svg {
        transform: scale(1.15);
      }
    }
  }
`

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${({ isDescription }) =>
    isDescription &&
    css`
      & h2 {
        margin: 0;
      }

      & p {
        margin: 1.5rem 0;
        text-align: center;
      }

      @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        box-sizing: border-box;
        width: 100vw;
        padding: 0 1.5rem;
      }
    `}
`

export const StyledContactUsButton = styled.a`
  text-align: center;
  background: #252525 !important;
  color: #fff !important;
  display: inline-block;
  width: 8.875rem !important;
  font-size: 1.125rem !important;
  font-weight: 700;
  padding: 16px 32px;
  text-decoration: none;
`

export const StyledDescription = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 2.5rem;
  letter-spacing: 0.05em;
  color: rgba(37, 37, 37, 0.8);

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    margin-top: 1.5rem;
  }
`
